import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { Controller } from '@commoncore/controller/Controller';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { TrashImplementation } from '../implementation/TrashImplementation';

export class TrashController extends Controller{
    public trashImplementation:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public universalService:any;
    public listService:any;
    localStorageSvc: LocalStorageSvc;
    loggerService: any
    listViewImpl:any;
    fileOperationsImplementation: any;

    public constructor(private globalService:GlobalService) {
      super(globalService);
      this.trashImplementation= TrashImplementation.getInstance(this.globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(this.globalService);
    }
    
    public static getInstance(connectionService):TrashController{
		if(this.singleInstance == null){
			this.singleInstance = new TrashController(connectionService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
        this.universalService=globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.listService = globalService.getListServiceRef();
        this.loggerService = globalService.getLoggerServiceRef();
        this.localStorageSvc = this.globalService.getLocalStorageSvcRef()    
    }

    getTrashedObjects(){
      this.universalService.listView = true;
      this.universalService.nameSort = null;
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["trash"] + '?limit=100' + this.listService.listViewSortOrder;
        this.trashImplementation.setHandler(this.globalService);
        try {
          this.trashImplementation.getTrashApi(url);
        } catch (exc) {
          this.loggerService.log("exception handled for photos tab");
        }
    }

    onScrollDown() {
        var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"];
        try {
          this.trashImplementation.createUrlForNextLinkOnDesktop(url);
        }
        catch (exc) {
          this.loggerService.log("exception in scroll down")
        }
      }
    
      onMobileScrollDown() {
        this.loggerService.log("inside mobile scroll down controller")
        var docheight = document.getElementById("trashFilesWrapperId").scrollHeight;
        var toppos = $(".scrollableContainer").scrollTop();
        var url = "";
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + this.trashImplementation.trashNextLink;
        try {
          this.loggerService.log("docheight and toppos",docheight,toppos)
          this.trashImplementation.createUrlForNextLinkOnMobile(docheight, toppos, url);
        }
        catch (exc) {
          this.loggerService.log("exception in scroll down",exc)
        }
    
      }
    
    
      decideScrollCall(event) {
        if (!this.universalService.isMobileDevice) {
          this.onScrollDown();
        } else if (this.universalService.isMobileDevice) {
          this.onMobileScrollDown();
        }
      }
      

      async restoreFiles(){
  
        this.universalService.showLoader = true;
        var result;
        this.fileOperationsImplementation.setHandler(this.globalService);
        this.fileOperationsImplementation.setRequiredDataForAdding(this.universalService.selectedNodes);
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + ENV_CONFIG.commonUrls["restore"]
        try{
        result = await this.trashImplementation.restoreFiles(url,this.universalService.objectsToBeAdded);
   
        this.loggerService.log("result is ==>",result)
          if(result == false){
            this.loggerService.log("few objects not restored")
          }
          if(this.universalService.showMobOptionMenu){
            this.universalService.showMobOptionMenu  = false;
          }
         
          // this.listService.deSelectAll(null);
          // this.getTrashedObjects();
          this.updateUIAfterPerformingAction(result["resp"]["objects"],"RESTORE")
          if(result["resp"]["usedSpace"]) {
            var userData = this.localStorageSvc.getUserData(true);
            if(userData && userData["quota"]){
              result["resp"]["usedSpace"] =  result["resp"]["usedSpace"] == 0 ? 0 : ( result["resp"]["usedSpace"] ?  result["resp"]["usedSpace"] : userData["quota"]["totalUsedQuota"]);
              userData["quota"]["totalUsedQuota"] =  result["resp"]["usedSpace"];
              console.log("userData::",userData)
              AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
              AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
            }
          }
        }catch(exc){
  
          this.universalService.showLoader = false;
          this.loggerService.log("exception in restore",exc)
        }
        
        
      }


      async deleteForever(){
        this.universalService.showLoader = true;
        var result;
        this.fileOperationsImplementation.setHandler(this.globalService);
        this.fileOperationsImplementation.setRequiredDataForAdding(this.universalService.selectedNodes);
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + ENV_CONFIG.commonUrls["deleteforever"]
        try{
        result = await this.trashImplementation.deleteFiles(url,this.universalService.objectsToBeAdded);
        this.loggerService.log("result is ==>",result)
          if(result == false){
            this.loggerService.log("few objects not deleted")
          }
          // this.listService.deSelectAll(null);
          // this.getTrashedObjects();
          this.updateUIAfterPerformingAction(result["resp"]["objects"],"DELETEFOREVER")
          this.universalService.openMoreOptions = false;
          this.universalService.showMobOptionMenu = false;
          //update used space
          if(result["resp"]["usedSpace"] || result["resp"]["usedSpace"] == 0) {
            let userData = this.localStorageSvc.getUserData(true);
            result["resp"]["usedSpace"] =  result["resp"]["usedSpace"] == 0 ? 0 : ( result["resp"]["usedSpace"] ?  result["resp"]["usedSpace"] : userData["quota"]["totalUsedQuota"]);
              userData["quota"]["totalUsedQuota"] =  result["resp"]["usedSpace"];
            AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
          }
        }catch(exc){
          this.loggerService.log("exception in delete",exc)
        }
      }

      async updateUIAfterPerformingAction(list,executedTask){
        var array = []
        array = this.trashImplementation.sortByDateArray;
        var result;
        if(executedTask == 'DELETEFOREVER' || executedTask == 'RESTORE'){
            this.fileOperationsImplementation.setHandler(this.globalService); 
            if(this.universalService.listView && !this.universalService.isMobileDevice){
              let deletedNodesLength = new Set(this.trashImplementation.listImpl.indexsArray);
              result = await this.trashImplementation.listImpl.updateSummaryCountsAndUI(array,this.trashImplementation.listImpl.indexsArray,executedTask);
              this.trashImplementation.trashfileslistsize = this.trashImplementation.trashfileslistsize - deletedNodesLength.size;
              if(this.listService.listOptions.api.getDisplayedRowCount() == 0){
                this.fetchNextPageData();
              }
            }else{
             result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
             if(result.length == 0 && this.universalService.foldersArray.length == 0){
              this.fetchNextPageData();
             }else{
                this.universalService.emptyTab = false;
                this.universalService.emptyFolder = false;
                this.universalService.emptyTrash = false;
             }
            }
            array = result;
        }else{
            this.loggerService.log("task invalid",executedTask)
        }
      }

      async fetchNextPageData(){
        // if(this.trashImplementation.trashNextLink != ""){
        //   var url = "";
        //   url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  this.trashImplementation.trashNextLink;
        //   try{
        //     this.listService.disableSelectionModeInListView = true;
        //     var result = await this.trashImplementation.fetchNextPageData(url);
        //     if(result["resp"]["objects"].length == 0){
        //       this.universalService.showLoader = true;
        //       this.getTrashedObjects();
        //     }else{
        //       this.universalService.emptyTab = false;
        //     }
        //   }
        //   catch(exc){
        //     this.loggerService.log("exception in scroll down")
        //   }
        // }else {
        //   if(this.universalService.foldersArray.length == 0) {
        //     this.universalService.emptyTrash = true;
        //   }
        // }
        this.getTrashedObjects();
      }

      selectAll(event){
        this.trashImplementation.selectAll(event)
      }
}